import type { IFilter } from '../models/IFilter.ts';

export const filterService = {
  getDateRangeFilters(start: Date, end: Date): IFilter[] {
    return [
      { DataField: 'StartDate', Type: '>', Value: start.toISOString() },
      { DataField: 'EndDate', Type: '<', Value: end.toISOString() },
    ];
  },
  getEqualFilter(DateField: string, Value: string): IFilter {
    return { DataField: DateField, Type: '=', Value: Value };
  },
};

export const DateFieldNames = {
  Employee: 'AssignedId',
  ParentId: 'id',
  StartDate: 'startDate',
  EndDate: 'endDate',
  Project: 'ProjectName',
  DetailedData: 'DetailedData',
  BcId: 'bc',
};
